import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import EditOrganizationForm from './EditOrganizationModalForm';
import GET_ORGANIZATIONS_INCLUDING_DISTRICT from 'graph/organization/get-organization-including-districts-query';
import UPDATE_ORGANIZATION_MUTATION from 'graph/organization/update-organization-mutation';
import useParseActionRouteParams from 'hooks/route-action/use-parse-action-route-params';
import PageContainer from 'components/@layout/PageContainer';
import { Organization } from 'types/schema-generated-types';

interface EditOrganizationModalProps {
  onClose: (success?: boolean) => void;
}
const EditOrganizationModal: React.FC<EditOrganizationModalProps> = ({ onClose }) => {
  const { organizationId } = useParseActionRouteParams<{ organizationId: string }>();
  const { data, loading, error } = useQuery(GET_ORGANIZATIONS_INCLUDING_DISTRICT, {
    variables: { where: { id: +organizationId } }
  });

  const [updateOrganization] = useMutation(UPDATE_ORGANIZATION_MUTATION);
  const organization = data?.organizations?.find((o: Organization) => o.id === +organizationId);

  return (
    <PageContainer loading={loading} error={error}>
      <EditOrganizationForm
        organization={organization || {}}
        onClose={onClose}
        updateOrganization={updateOrganization}
      />
    </PageContainer>
  );
};

export default EditOrganizationModal;
